import { useSelector } from 'react-redux';
import {
  isNetworkAdminSelector,
  makeIsCompanyAdminSelector,
  canManageCompaniesSelector,
  isOrganizationManagerSelector,
} from './selectors';

const usePermissions = (props) => {
  const { companySlug = '' } = props || {};
  const isNetworkAdmin = useSelector(isNetworkAdminSelector);
  const isOrganizationManager = useSelector(isOrganizationManagerSelector);
  const isCompanyAdmin = useSelector(makeIsCompanyAdminSelector(companySlug));
  const canManageCompanies = useSelector(canManageCompaniesSelector);

  return {
    company: {
      canManageCompanies,
      canManageGeneralInformation: isNetworkAdmin || isCompanyAdmin,
      canManageManuallyPostedJobs: isNetworkAdmin || isCompanyAdmin,
      canAddCompanyAdmins: isNetworkAdmin || isCompanyAdmin,
      canRemoveCompanyAdmins: isCompanyAdmin,
    },
    notifications: { canManageNotifications: isNetworkAdmin || isOrganizationManager },
  };
};

export default usePermissions;
